import { DecodeVinResponse, PostalResponse, ProductFormResponse } from '@app-model/api';
import { FinanceType, Options, ShoppingFlowType, VehicleConditionType, VehicleType } from '@app-model/enums';
import { IComplexDate } from '@app-shared/utils';

import * as VehicleActions from './vehicle.actions';

export interface State {
  decodeVinTries: number;
  error: string;
  postal: PostalResponse;
  productForm: ProductFormResponse;
  status: boolean;
  values: VehicleValues;
  vin: DecodeVinResponse;
}

export interface VehicleValues {
  vin: string;
  hin?: string;
  pid?: string;
  tin?: string;
  vehicleType: VehicleType;
  year: string;
  make: string;
  model: string;
  trim: string;
  other: string;
  odometer: string;
  isAfterSale: Options;
  financeType: FinanceType;
  vehicleCondition: VehicleConditionType;
  surcharges: { name: string; selected?: boolean }[];
  msrp: string;
  grossCapCost: string;
  financeAmount: number;
  loanTerm: number;
  apr: number;
  purchasePrice: string;
  amortizationPeriod: number;
  residualValue: string;
  coBorrower: Options;
  province: string;
  provinceCoBorrower: string;
  DOBBorrower: IComplexDate;
  DOBCoBorrower: IComplexDate;
  flowType: ShoppingFlowType;
  addInsurance: Options;
  customerTaxExempt: Options;
  negativeEquity: Options;
  registrationNumber: string;
  saleDate: IComplexDate;
  inServiceDate: IComplexDate;
  purchaseDate: IComplexDate;
  monthlyPayment?: string;
}


const InitialState: State = {
  decodeVinTries: 0,
  error: '',
  postal: new PostalResponse(),
  productForm: new ProductFormResponse(),
  status: false,
  values: {} as VehicleValues,
  vin: new DecodeVinResponse(),
};

export function reducer(state: State = InitialState, action: VehicleActions.All): State {
  switch (action.type) {
    case VehicleActions.GET_PRODUCT_FORM_SUCCESS: {
      return { ...state, productForm: action.payload };
    }

    case VehicleActions.UPDATE_PRODUCT_FORM: {
      return { ...state, values: action.payload };
    }

    case VehicleActions.GET_CUSTOMER_POSTAL_SUCCESS: {
      return { ...state, postal: action.payload };
    }

    case VehicleActions.DECODE_VIN_SUCCESS: {
      return { ...state, vin: action.payload, decodeVinTries: 0, error: '' };
    }

    case VehicleActions.CLEAR_CUSTOMER_POSTAL: {
      return { ...state, postal: new PostalResponse() };
    }

    case VehicleActions.DECODE_VIN_MANUAL: {
      return { ...state, vin: action.payload, error: '' };
    }

    case VehicleActions.SHOW_INSERVICE_DATE_AND_ODO: {
      const vin = state.vin;
      vin.manualDecode = true;

      return { ...state, vin: vin, error: '' };
    }

    case VehicleActions.LOAD_VEHICLE_QUOTE: {
      action.payload.VehicleState.vin['loadQuote'] = true;

      return {
        ...state,
        postal: action.payload.VehicleState.postal ? action.payload.VehicleState.postal : new PostalResponse(),
        productForm: action.payload.VehicleState.productForm,
        status: action.payload.VehicleState.status,
        values: action.payload.VehicleState.values,
        vin: action.payload.VehicleState.vin,
      };
    }

    case VehicleActions.VEHICLE_FAILURE: {
      const vinReset = new DecodeVinResponse();
      vinReset.vin = state.vin.vin;

      return {
        ...state,
        error: action.payload,
        vin: vinReset,
        decodeVinTries: state.decodeVinTries + 1,
      };
    }

    case VehicleActions.RESET_PRODUCT_FORM: {
      return {
        ...state,
        decodeVinTries: 0,
        error: '',
        postal: new PostalResponse(),
        status: false,
        values: {} as VehicleValues,
        vin: new DecodeVinResponse(),
      };
    }

    default: {
      return state;
    }
  }
}
